class ConstantsService {

  constructor($rootScope) {
    "ngInject";
    $rootScope.apiHost = API_HOST;
  }

}

export default ConstantsService;



// WEBPACK FOOTER //
// ./client/common/services/constants/constants.service.js